import React, { useState } from 'react'
import PropTypes from 'prop-types'

import {
  DropdownIcon,
  SimpleWrapper,
  SimpleLabel,
  SelectList,
  SelectButton,
  ListWrapper,
} from './style'

const SimpleDropdown = ({
  data,
  label,
  onSelect,
  placeholder,
  icon,
  minWidth,
  renderItem: RenderItem,
  keyExtractor
}) => {
  const [listOpened, setListOpened] = useState(false)
  const toggleList = () => setListOpened(currentState => !currentState)

  return (
  <SimpleWrapper minWidth={minWidth}>
    <SimpleLabel>
      {icon}
      {label}
    </SimpleLabel>
    <ListWrapper>
      <SelectButton onClick={() => toggleList()}>
        {placeholder}
        <DropdownIcon open={listOpened} width="14px" />
      </SelectButton>
      <SelectList open={listOpened}>
        {data.map(item => !RenderItem ? (
            <SelectButton key={item} onClick={() => {
              onSelect(item)
              toggleList()
            }}>
              {item}
            </SelectButton>
          ) : (
            <RenderItem itemData={item} closeDropdown={() => setListOpened(() => false)} key={keyExtractor(item)} />
          )
        )}
      </SelectList>
    </ListWrapper>
  </SimpleWrapper>
  )
}

export * from './style'

SimpleDropdown.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array]),
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  onSelect: PropTypes.func,
  placeholder: PropTypes.string,
  icon: PropTypes.node,
  minWidth: PropTypes.number,
  renderItem: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  keyExtractor: PropTypes.func
}

SimpleDropdown.defaultProps = {
  data: [],
  label: '',
  onSelect: null,
  placeholder: '',
  icon: null,
  minWidth: 'initial',
  renderItem: null,
  keyExtractor: (item) => item
}

export default SimpleDropdown